import React, { useEffect, useState } from "react";
import { Card } from "../../tremor/Card";
import { Label } from "../../tremor/Text";
import { Text } from "../../tremor/Text";
const ProgressBar = () => {
    const [progress, setProgress] = useState(0);
    useEffect(() => {
        const interval = setInterval(() => {
            setProgress((prevProgress) => {
                if (prevProgress >= 99) {
                    clearInterval(interval);
                    return 99;
                }
                if (prevProgress >= 80) {
                    return Math.min(100, prevProgress + 1);
                }
                if (prevProgress >= 60) {
                    return Math.min(100, prevProgress + 2);
                }
                if (prevProgress >= 40) {
                    return Math.min(100, prevProgress + 3);
                }
                return prevProgress + 4;
            });
        }, 1000);
        return () => {
            clearInterval(interval);
        };
    }, []);
    return (React.createElement("div", { className: "onvo-w-full onvo-h-2 onvo-rounded-md onvo-bg-slate-200 dark:onvo-bg-slate-700" },
        React.createElement("div", { className: "onvo-h-full onvo-transition-all onvo-duration-1000 onvo-ease-linear onvo-rounded-md onvo-bg-blue-500", style: { width: progress + "%" } })));
};
export const ChartPlaceholder = ({ className }) => (React.createElement(Card, { className: "onvo-relative onvo-w-full onvo-flex onvo-flex-col onvo-min-h-72 onvo-animate-pulse " +
        className },
    React.createElement("div", { className: "onvo-h-6 onvo-bg-slate-200 onvo-rounded-md dark:onvo-bg-slate-700 onvo-w-72 onvo-mb-2.5" }),
    React.createElement("div", { className: "onvo-w-48 onvo-h-4 onvo-mb-10 onvo-bg-slate-200 onvo-rounded-md dark:onvo-bg-slate-700" }),
    React.createElement("div", { className: "onvo-flex onvo-h-full onvo-w-full onvo-relative onvo-flex-grow onvo-items-baseline onvo-gap-2" },
        React.createElement("div", { className: "onvo-flex-grow onvo-bg-slate-200 onvo-rounded-t-md onvo-h-[40%] dark:onvo-bg-slate-700" }),
        React.createElement("div", { className: "onvo-flex-grow onvo-bg-slate-200 onvo-rounded-t-md onvo-h-[60%] dark:onvo-bg-slate-700" }),
        React.createElement("div", { className: "onvo-flex-grow onvo-bg-slate-200 onvo-rounded-t-md onvo-h-[40%] dark:onvo-bg-slate-700" }),
        React.createElement("div", { className: "onvo-flex-grow onvo-bg-slate-200 onvo-rounded-t-md onvo-h-[100%] dark:onvo-bg-slate-700" }),
        React.createElement("div", { className: "onvo-flex-grow onvo-bg-slate-200 onvo-rounded-t-md onvo-h-[100%] dark:onvo-bg-slate-700" }),
        React.createElement("div", { className: "onvo-flex-grow onvo-bg-slate-200 onvo-rounded-t-md onvo-h-[40%] dark:onvo-bg-slate-700" }),
        React.createElement("div", { className: "onvo-flex-grow onvo-bg-slate-200 onvo-rounded-t-md onvo-h-[100%] dark:onvo-bg-slate-700" }),
        React.createElement("div", { className: "onvo-flex-grow onvo-bg-slate-200 onvo-rounded-t-md onvo-h-[40%] dark:onvo-bg-slate-700" }),
        React.createElement("div", { className: "onvo-flex-grow onvo-bg-slate-200 onvo-rounded-t-md onvo-h-[60%] dark:onvo-bg-slate-700" }),
        React.createElement("div", { className: "onvo-flex-grow onvo-bg-slate-200 onvo-rounded-t-md onvo-h-[40%] dark:onvo-bg-slate-700" })),
    React.createElement("span", { className: "onvo-sr-only" }, "Loading...")));
export const ChartLoader = ({ id, className }) => {
    const [message, setMessage] = useState("");
    // useEffect(() => {
    //   if (!id) return;
    //   let url = (location.hostname === "localhost" || location.hostname === "127.0.0.1") ? "wss://localhost:3000" : "wss://data-service-315915221063.us-central1.run.app"
    //   const ws = new WebSocket(`${url}/jobs/${id}`);
    //   ws.onmessage = (event) => {
    //     console.log("Message from job in chart loader: ", event.data);
    //     // setMessage(msg => msg + event.data.message);
    //   };
    // }, [id]);
    return (React.createElement("div", { className: "onvo-loader-question-modal onvo-relative onvo-flex onvo-flex-row onvo-gap-3 onvo-items-start onvo-justify-start onvo-w-full" },
        React.createElement("div", { className: "onvo-w-full onvo-flex onvo-flex-col onvo-gap-2" },
            React.createElement(Text, null, message),
            React.createElement(Label, { className: "onvo-mt-2" }, "\u2728 Auto-magically generating your widget..."),
            React.createElement(ProgressBar, null),
            React.createElement(ChartPlaceholder, { className: "onvo-h-72" }))));
};
//# sourceMappingURL=ChartLoader.js.map